import styled from "styled-components";

export const Wrapper = styled.div`
canvas{
width:100% !important;
}
`